export enum ModalSeverityValues {
  INFO = 'info', // general information modal
  ERROR = 'error', // a modal shown due to an error
  CONFLICT = 'conflict', // usually a BE triggered error e.g. trolley conflict
}
